/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiAPlayPauseIcon20Light = forwardRef('MediaUiAPlayPauseIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M15.5 3a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-1 0v-13a.5.5 0 0 1 .5-.5Z" }),
        React.createElement("path", { d: "M19.5 3a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-1 0v-13a.5.5 0 0 1 .5-.5Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.7 3.185a1.1 1.1 0 0 0-1.7.922v11.786a1.1 1.1 0 0 0 1.7.922l8.793-5.726a1.3 1.3 0 0 0 0-2.178L3.7 3.185Zm-.7.922a.1.1 0 0 1 .155-.084l8.793 5.726a.3.3 0 0 1 0 .502l-8.793 5.726A.1.1 0 0 1 3 15.893V4.107Z" })));
});
